// This is a bit of mess with regards to the input.
export const Author = (props: { author: string }) => {
  const { author } = props;
  let image;
  switch (author) {
    case "Raza Habib":
      image = "/assets/headshots/raza.png";
      break;
    case "Jordan Burgess":
      image = "/assets/headshots/jordan.png";
      break;
    case "Peter Hayes":
      image = "/assets/headshots/peter.png";
      break;
    case "Harry Xie":
      image = "/assets/headshots/harry.png";
      break;
    case "Tom Keefe":
      image = "/assets/headshots/tom.png";
      break;
    case "Emine Yilmaz":
      image = "/assets/headshots/emine.png";
      break;
    case "David Barber":
      image = "/assets/headshots/david.png";
      break;
    default:
      image = "/assets/logs/padded.png";
  }

  return (
    <div className="flex items-center gap-12">
      <div className="flex min-w-0 shrink items-center gap-16">
        <div
          className=" h-40 w-40 shrink-0 rounded-full bg-cover bg-center shadow-inner-border dark:shadow-none"
          title={props.author}
          style={{
            backgroundImage: `url(${image})`,
          }}
        />
      </div>
      <span className="text-14-20 text-gray-700 dark:text-white">
        {props.author}
      </span>
    </div>
  );
};
